import { ThemeTypographyObject, VariantObjects } from '../types/theme';

type CHARTLegacyTypeTypography = 'CHARTcallout'
  | 'CHARTbody'
  | 'CHARTbodySmall'
  | 'CHARTbodyBold'
  | 'CHARTbodyInverse'
  | 'CHARTnavLabel'
  | 'CHARTnavText'
  | 'CHARTnavHeader'
  | 'CHARTsubhead'
  | 'CHARTlink'
  | 'CHARTcard'
  | 'CHARTquoteXL'
  | 'CHARTquoteL'
  | 'CHARTquoteM'
  | 'CHARTquoteS'
  | 'CHARTquoteXS'
  | 'CHARTattribution'
  | 'CHARTdisclaimer'
  | 'CHARTintroXS300'
  | 'CHARTbodyS400';

type LegacyCHARTypographyVariants = VariantObjects<CHARTLegacyTypeTypography, ThemeTypographyObject>;

const chartLegacyTypography: LegacyCHARTypographyVariants = {
  CHARTcallout: {
    fontWeight: 'normal',
    fontSize: [4, 5, 5, 5],
    lineHeight: 'body',
    marginBottom: 5,
    color: 'text'
  },
  CHARTbody: {
    fontWeight: 'normal',
    fontSize: 4,
    marginBottom: 5,
    color: 'text'
  },
  CHARTbodySmall: {
    fontWeight: 'normal',
    fontSize: 3,
    marginBottom: 3,
    color: 'text'
  },
  CHARTbodyBold: {
    fontWeight: 'bolder',
    fontSize: 4,
    marginBottom: 3,
    color: 'text'
  },
  CHARTbodyInverse: {
    fontWeight: 'normal',
    fontSize: 3,
    lineHeight: 'body',
    marginBottom: 6,
    color: 'white'
  },
  CHARTnavLabel: {
    fontWeight: 'normal',
    fontSize: 2,
    margin: 0,
    padding: 0
  },
  CHARTnavText: {
    fontWeight: 'normal',
    fontSize: 2,
    margin: 0,
    padding: '4px 0 0 !important'
  },
  CHARTnavHeader: {
    fontWeight: 'bold',
    fontSize: 3,
    margin: 0,
    padding: '0 !important'
  },
  CHARTsubhead: {
    fontWeight: 'light',
    fontSize: [4, 4, 5, 5],
    marginBottom: 5
  },
  CHARTlink: {
    fontSize: 3,
    fontWeight: 'bold',
    color: 'primary'
  },
  CHARTcard: {
    fontSize: 3,
    fontWeight: 'normal',
    color: 'blueSteel'
  },
  CHARTquoteXL: {
    fontWeight: 'light',
    fontSize: 8,
    lineHeight: 'body',
    marginBottom: 6,
    color: 'blueSteel'
  },
  CHARTquoteL: {
    fontWeight: 'light',
    fontSize: [5, 5, 5, 5, 6],
    lineHeight: 'body',
    marginBottom: 6,
    color: 'blueSteel'
  },
  CHARTquoteM: {
    fontWeight: 'light',
    fontSize: [4, 4, 4, 4, 5],
    lineHeight: 'body',
    marginBottom: 6,
    color: 'blueSteel'
  },
  CHARTquoteS: {
    fontWeight: 'light',
    fontSize: 4,
    lineHeight: 'body',
    marginBottom: 6,
    color: 'blueSteel'
  },
  CHARTquoteXS: {
    fontWeight: 'light',
    fontSize: 3,
    lineHeight: 'body',
    marginBottom: 6,
    color: 'blueSteel'
  },
  CHARTattribution: {
    fontSize: 2,
    fontWeight: 'body',
    margin: 0,
    fontStyle: 'italic'
  },
  CHARTdisclaimer: {
    fontWeight: 'body',
    fontSize: 0
  },
  CHARTintroXS300: {
    fontWeight: 'light',
    fontSize: 4,
    lineHeight: 1.2,
    marginBottom: 4,
    color: 'coolGrey.50'
  },
  CHARTbodyS400: {
    fontWeight: 'normal',
    fontSize: 3,
    lineHeight: 'body',
    color: 'coolGrey.100'
  }
};

type COLegacyTypeTypography = 'COcallout'
  | 'CObody'
  | 'CObodySmall'
  | 'CObodyBold'
  | 'CObodyInverse'
  | 'COnavLabel'
  | 'COnavText'
  | 'COnavHeader'
  | 'COsubhead'
  | 'COlink'
  | 'COcard'
  | 'COquoteXL'
  | 'COquoteL'
  | 'COquoteM'
  | 'COquoteS'
  | 'COquoteXS'
  | 'COquoteXS300'
  | 'COlabelsM400'
  | 'COintroXS300'
  | 'COintroS300'
  | 'CObodyM400'
  | 'CObodyS400'
  | 'COformXS400'
  | 'COfinePrintM400'
  | 'COheroText'
  | 'COlinkS500'
  | 'CObodyText';

type LegacyCOTypographyVariants =  VariantObjects<COLegacyTypeTypography, ThemeTypographyObject>;

const coLegacyTypeTypography: LegacyCOTypographyVariants = {
  COcallout: {
    fontWeight: 'normal',
    fontSize: [4, 5, 5, 5],
    lineHeight: 'body',
    marginBottom: 5,
    color: 'text'
  },
  CObody: {
    fontWeight: 'normal',
    fontSize: 4,
    marginBottom: 5,
    color: 'text'
  },
  CObodySmall: {
    fontWeight: 'normal',
    fontSize: 3,
    marginBottom: 3,
    color: 'text'
  },
  CObodyBold: {
    fontWeight: 'bolder',
    fontSize: 4,
    marginBottom: 3,
    color: 'text'
  },
  CObodyInverse: {
    fontWeight: 'normal',
    fontSize: 3,
    lineHeight: 'body',
    marginBottom: 6,
    color: 'white'
  },
  COnavLabel: {
    fontWeight: 'normal',
    fontSize: 2,
    margin: 0,
    padding: 0
  },
  COnavText: {
    fontWeight: 'normal',
    fontSize: 2,
    margin: 0,
    padding: '4px 0 0 !important'
  },
  COnavHeader: {
    fontWeight: 'bold',
    fontSize: 3,
    margin: 0,
    padding: '0 !important'
  },
  COsubhead: {
    fontWeight: 'light',
    fontSize: [4, 4, 5, 5],
    marginBottom: 5
  },
  COlink: {
    fontSize: 3,
    fontWeight: 'bold',
    color: 'primary'
  },
  COcard: {
    fontSize: 3,
    fontWeight: 'normal',
    color: 'blueSteel'
  },
  COquoteXL: {
    fontWeight: 'light',
    fontSize: 8,
    lineHeight: 'body',
    marginBottom: 6,
    color: 'blueSteel'
  },
  COquoteL: {
    fontWeight: 'light',
    fontSize: [5, 5, 5, 5, 6],
    lineHeight: 'body',
    marginBottom: 6,
    color: 'blueSteel'
  },
  COquoteM: {
    fontWeight: 'light',
    fontSize: [4, 4, 4, 4, 5],
    lineHeight: 'body',
    marginBottom: 6,
    color: 'blueSteel'
  },
  COquoteS: {
    fontWeight: 'light',
    fontSize: 4,
    lineHeight: 'body',
    marginBottom: 6,
    color: 'blueSteel'
  },
  COquoteXS: {
    fontWeight: 'light',
    fontSize: 3,
    lineHeight: 'body',
    marginBottom: 6,
    color: 'blueSteel'
  },
  COquoteXS300: {
    fontWeight: 300,
    fontSize: 4,
    lineHeight: 1.6,
    color: 'coolGrey.100'
  },
  COlabelsM400: {
    fontWeight: 500,
    fontSize: 2,
    lineHeight: 1,
    color: 'coolGrey.100'
  },
  COintroXS300: {
    fontWeight: 'light',
    fontSize: 4,
    lineHeight: 1.2,
    marginBottom: 4,
    color: 'coolGrey.50'
  },
  COintroS300: {
    fontWeight: 'light',
    fontSize: 5,
    lineHeight: 1.2,
    marginBottom: 4,
    color: 'coolGrey.50'
  },
  CObodyM400: {
    fontWeight: 400,
    fontSize: 4,
    lineHeight: 1.6,
    color: 'coolGrey.100'
  },
  CObodyS400: {
    fontWeight: 'normal',
    fontSize: 3,
    lineHeight: 'body',
    color: 'coolGrey.100'
  },
  COformXS400: {
    fontSize: 2
  },
  COfinePrintM400: {
    fontSize: 2
  },
  COheroText: {
    fontWeight: 'light',
    fontSize: 4,
    lineHeight: 'body',
    marginBottom: 6,
    color: 'blueSteel',
    fontFamily: 'body'
  },
  COlinkS500: {
    fontWeight: 600,
    fontSize: 3
  },
  CObodyText: {
    fontWeight: 'normal',
    fontSize: 3,
    lineHeight: 'body',
    marginBottom: 5,
    color: 'text',
    fontFamily: 'body'
  }
};

type EDULegacyTypeTypography = 'EDUbody'
  | 'EDUbodySmall'
  | 'EDUbodyTiny'
  | 'EDUcard'
  | 'EDUsubhead'
  | 'EDUassignmentType'
  | 'EDUquoteXL'
  | 'EDUquoteL'
  | 'EDUquoteM'
  | 'EDUquoteS'
  | 'EDUquoteXS'
  | 'EDUnavLabel'
  | 'EDUnavText'
  | 'EDUnavHeader';

type LegacyEDUTypographyVariants =  VariantObjects<EDULegacyTypeTypography, ThemeTypographyObject>;

const eduLegacyTypography: LegacyEDUTypographyVariants = {
  EDUbody: {
    fontWeight: 'normal' as const,
    fontSize: 4,
    marginBottom: 5,
    color: 'text'
  },
  EDUbodySmall: {
    fontWeight: 'normal' as const,
    fontSize: 3,
    color: 'text'
  },
  EDUbodyTiny: {
    fontWeight: 'normal' as const,
    fontSize: 2,
    color: 'text'
  },
  EDUcard: {
    fontSize: 3,
    fontWeight: 'normal',
    color: 'primaryText'
  },
  EDUsubhead: {
    fontWeight: 'light',
    fontSize: [4, 4, 5, 5],
    marginBottom: 5
  },
  EDUassignmentType: {
    color: 'disabledBorder',
    fontSize: 4,
    lineHeight: 'body',
    fontWeight: 'subheading',
    marginBottom: 24
  },
  EDUquoteXL: {
    fontWeight: 'light',
    fontSize: 8,
    lineHeight: 'default',
    marginBottom: 6,
    color: 'blueSteel'
  },
  EDUquoteL: {
    fontWeight: 'light',
    fontSize: 8,
    lineHeight: 'default',
    marginBottom: 6,
    color: 'blueSteel'
  },
  EDUquoteM: {
    fontWeight: 'light',
    fontSize: 8,
    lineHeight: 'default',
    marginBottom: 6,
    color: 'blueSteel'
  },
  EDUquoteS: {
    fontWeight: 'light',
    fontSize: 4,
    lineHeight: 'default',
    marginBottom: 6,
    color: 'blueSteel'
  },
  EDUquoteXS: {
    fontWeight: 'light',
    fontSize: 3,
    lineHeight: 'body',
    marginBottom: 6,
    color: 'blueSteel'
  },
  EDUnavLabel: {
    fontWeight: 'normal',
    fontSize: 2,
    margin: 0,
    padding: 0
  },
  EDUnavText: {
    fontWeight: 'normal',
    fontSize: 2,
    margin: 0,
    padding: '4px 0 0 !important'
  },
  EDUnavHeader: {
    fontWeight: 'bold',
    fontSize: 3,
    margin: 0,
    padding: '0 !important'
  }
};

type PRESSLegacyTypeTypography = 'PRESSquoteXL'
  | 'PRESSquoteL'
  | 'PRESSquoteM'
  | 'PRESSquoteS'
  | 'PRESSquoteXS';

type LegacyPRESSTypographyVariants =  VariantObjects<PRESSLegacyTypeTypography, ThemeTypographyObject>;

const pressLegacyTypography: LegacyPRESSTypographyVariants = {
  PRESSquoteXL: {
    fontWeight: 'light',
    fontSize: 8,
    lineHeight: 'default',
    marginBottom: 6,
    color: 'blueSteel'
  },
  PRESSquoteL: {
    fontWeight: 'light',
    fontSize: 8,
    lineHeight: 'default',
    marginBottom: 6,
    color: 'blueSteel'
  },
  PRESSquoteM: {
    fontWeight: 'light',
    fontSize: 8,
    lineHeight: 'default',
    marginBottom: 6,
    color: 'blueSteel'
  },
  PRESSquoteS: {
    fontWeight: 'light',
    fontSize: 8,
    lineHeight: 'default',
    marginBottom: 6,
    color: 'blueSteel'
  },
  PRESSquoteXS: {
    fontWeight: 'light',
    fontSize: 8,
    lineHeight: 'default',
    marginBottom: 6,
    color: 'blueSteel'
  }
};

type SPARKLegacyTypeTypography = 'SPARKbody'
  | 'SPARKbodySmall'
  | 'SPARKbodyS400'
  | 'SPARKsubhead'
  | 'SPARKintroL'
  | 'SPARKintroS'
  | 'SPARKintroXS300'
  | 'SPARKquoteL'
  | 'SPARKquoteM'
  | 'SPARKnavLabel'
  | 'SPARKnavText'
  | 'SPARKnavHeader'
  | 'SPARKheroText'
  | 'SPARKbodyText';

type LegacySPARKTypographyVariants =  VariantObjects<SPARKLegacyTypeTypography, ThemeTypographyObject>;

const sparkLegacyTypography: LegacySPARKTypographyVariants = {
  SPARKbody: {
    fontWeight: 'normal' as const,
    lineHeight: 'body',
    fontSize: 4,
    marginBottom: 5,
    color: 'text'
  },
  SPARKbodySmall: {
    fontWeight: 'normal',
    fontSize: 3,
    lineHeight: 'body',
    marginBottom: 3,
    color: 'text'
  },
  SPARKbodyS400: {
    fontWeight: 'body',
    fontSize: 3,
    lineHeight: 'body',
    marginBottom: 3,
    color: 'text'
  },
  SPARKsubhead: {
    fontWeight: 'light',
    lineHeight: 'body',
    fontSize: [4, 4, 5, 5],
    marginBottom: 5
  },
  SPARKintroL: {
    fontWeight: 'light',
    fontSize: [5, 5, 5, 6, 7],
    lineHeight: 'body',
    marginBottom: 6
  },
  SPARKintroS: {
    fontWeight: 'light',
    fontSize: [4, 4, 4, 4, 5],
    lineHeight: 'body',
    marginBottom: 6
  },
  SPARKintroXS300: {
    fontWeight: 'bold',
    fontSize: 3,
    lineHeight: 'body'
  },
  SPARKquoteL: {
    fontWeight: 'light',
    fontSize: [5, 5, 5, 5, 6],
    lineHeight: 'body',
    marginBottom: 6,
    color: 'blueSteel'
  },
  SPARKquoteM: {
    fontWeight: 'light',
    fontSize: [4, 4, 4, 4, 5],
    lineHeight: 'body',
    marginBottom: 6,
    color: 'blueSteel'
  },
  SPARKnavLabel: {
    fontWeight: 'normal',
    fontSize: 2,
    margin: 0,
    padding: 0
  },
  SPARKnavText: {
    fontWeight: 'normal',
    fontSize: 2,
    lineHeight: 'body',
    margin: 0,
    padding: '4px 0 0 !important'
  },
  SPARKnavHeader: {
    fontWeight: 'bold',
    fontSize: 3,
    margin: 0,
    padding: '0 !important'
  },
  SPARKheroText: {
    fontWeight: 'light',
    fontSize: 4,
    lineHeight: 'body',
    marginBottom: 6,
    color: 'blueSteel',
    fontFamily: 'body'
  },
  SPARKbodyText: {
    /* eslint-disable-next-line @typescript-eslint/prefer-as-const */
    fontWeight: 'normal' as 'normal',
    fontSize: 3,
    lineHeight: 'body',
    marginBottom: 5,
    color: 'text',
    fontFamily: 'body'
  }
};

export type AllLegacyTypographyTypeVariants = CHARTLegacyTypeTypography
  | COLegacyTypeTypography
  | EDULegacyTypeTypography
  | PRESSLegacyTypeTypography
  | SPARKLegacyTypeTypography;

const legacyTypographyVariants = {
  ...chartLegacyTypography,
  ...coLegacyTypeTypography,
  ...eduLegacyTypography,
  ...pressLegacyTypography,
  ...sparkLegacyTypography
};

export const allLegacyTypographyKeyVariants = Object.keys(legacyTypographyVariants);

export default legacyTypographyVariants;
